import React from "react";  
import logo from '../Assets/HT logo round.png';
import styles from './BottomNav.module.css';
import { Link, useLocation } from 'react-router-dom';

const BottomNav = () => {
    const location = useLocation();
    return (
        <div className={styles.bottomNav}>
            <div className={styles.logos}>
                <div className={styles.name}>Hyzerberg Technologies</div>
                <img className={styles.ht} src={logo} alt="HT logo"></img>
            </div> 
            <div className={styles.links}>
                <Link 
                to="/contact" 
                className={location.pathname === '/contact' ? `${styles.link} ${styles.active}` : styles.link}>
                Contact
                </Link>
                <Link 
                to="/about" 
                className={location.pathname === '/about' ? `${styles.link} ${styles.active}` : styles.link}>
                About
                </Link>
                <Link
                to="/status"
                className={location.pathname === '/status' ? `${styles.link} ${styles.active}` : styles.link}
                >
                Current Status
                </Link>
                <Link
                to="/faq"
                className={location.pathname === '/faq' ? `${styles.link} ${styles.active}` : styles.link}
                >
                FAQ
                </Link>
            </div>
            
        </div>
    )
}

export default BottomNav;